import Container from "../Container";
import SingleCrousel from "../Crousel";
import SearchBar from "../searchBar/searchBar";
import AdvancedSearch from "../searchBar/AdvancedSearch";
import "./homePage.scss";
import { useNavigate } from "react-router-dom";

function HomePage() {
  const navigate = useNavigate();
  const heroData = [
    {
      key: 1,
      title: "Samanvaya Lotus Lea",
      description: "2455 Area Details 2021 Year Built",
      price: "9000000",
      imgUrl: "/h1.jpg",
    },
    {
      key: 2,
      title: "Samanvaya Lotus Lea",
      description: "2455 Area Details 2021 Year Built",
      price: "1000000",
      imgUrl: "/h2.jpg",
    },
    {
      key: 3,
      title: "Samanvaya Lotus Lea",
      description: "2455 Area Details 2021 Year Built",
      price: "6000000",
      imgUrl: "/h3.jpg",
    },
  ];

  const handleSearch = (query) => {
  //  console.log("query___eeeee",query);
    navigate('/Property', { state: { query } });
  };

const handleAdvanceSearch = (data) => {
  console.log("Advanced Search Data:", data);
    // Navigate to /Property with state
    navigate('/Property', { state: { data } });
  };
  return (
   
  <>
<div className="homePage">
<div className="homePageGridLayout padingm">
  <div className="homePageLeft">
    <div className="wrapper">
      <div className="advanceSerach hidden md:block">
        <AdvancedSearch
          propertyTypes={["Apartments", "Villas", "Plots", "Row Houses", "Villaments", "Commercial Properties", "Pent Houses"]}
          budgets={[5, 10, 20, 30, 40, 50, 75, 100, 200, 300, 400, 500, 750, 1000, 1500, 2000]}
          onSearch={handleAdvanceSearch}
        />
      </div>
      <h1 className="title mobile">
        <span>Find</span>
        <span>Real</span>
        <span>Estate</span>
        <span>&</span>
        <span>Get</span>
        <br />
        <span>Your</span>
        <span>Dream</span>
        <span>Place</span>
      </h1>
      <p>
        Step into a world of refined opulence as you enter the grand foyer
        adorned with exquisite marble flooring and cascading crystal chandeliers...
      </p>
    </div>
  </div>

  <div className="homePageRight">
    <SingleCrousel data={heroData} />
    <div className="mt-2 mb-32 md:hidden mobile">
      <AdvancedSearch
          propertyTypes={["Apartments", "Villas", "Plots", "Row Houses", "Villaments", "Commercial Properties", "Pent Houses"]}
          budgets={[5, 10, 20, 30, 40, 50, 75, 100, 200, 300, 400, 500, 750, 1000, 1500, 2000]}
          onSearch={handleAdvanceSearch}
        />
    </div>
  </div>
</div>
</div>

    {/* <div className="homePage padingm">

    
      <div className="textContainer">
        <div className="wrapper">
          <div className="hidden md:block">
              <AdvancedSearch
                propertyTypes={["Apartments", "Villas", "Plots","Plots","Row Houses","Villaments","Commercial Properties","Pent Houses"]}
                budgets={[5, 10, 20, 30, 40, 50, 75, 100, // up to 1 Cr
                200, 300, 400, 500,             // 2 Cr to 5 Cr
                750, 1000, 1500, 2000 ]}
                //onSearch={(data) => console.log("Search submitted:", data)}
                onSearch={handleAdvanceSearch}
              /> */}
            {/* <SearchBar onFilterChange={handleSearch} /> */}
          {/* </div>
          <h1 className="title">
            <span>Find</span>
            <span>Real</span>
            <span>Estate</span>
            <span>&</span>
            <span>Get</span>
            <br />
            <span>Your</span>
            <span>Dream</span>
            <span>Place</span>
          </h1>
          <p>
            Step into a world of refined opulence as you enter the grand foyer
            adorned with exquisite marble flooring and cascading crystal
            chandeliers...
          </p>
        </div>
      </div> */}

      {/* Carousel + SearchBar for mobile */}
      {/* <div>
        <SingleCrousel data={heroData} />
        <div className="mt-3 mb-32 md:hidden">
          <SearchBar onFilterChange={handleSearch} />
        </div>
      </div>
    </div> */}
  </>
);

   
}

export default HomePage;
